import React, { useEffect, useRef } from 'react';
import { useAudioPlayerStore } from '@hts/shared/libs/zustand';

export const GlobalAudioElement: React.FC = () => {
  const audioRef = useRef<HTMLAudioElement>(null);

  const { setAudioElement } = useAudioPlayerStore();

  useEffect(() => {
    if (audioRef.current) {
      setAudioElement(audioRef.current);
    }

    return () => {
      setAudioElement(null);
    };
  }, [setAudioElement]);

  return <audio ref={audioRef} style={{ display: 'none' }} />;
};
